import http from '@/plugins/axios/axios';

export default class MotivoAfastamentoService {

    listar(requisicao) {
        return http.post('/api/motivo-de-afastamentos/listar', requisicao);
    }  
    
    salvar(requisicao) {
        return http.post('/api/motivo-de-afastamentos/salvar', requisicao);
    }

    excluir(requisicao) {
        return http.post('/api/motivo-de-afastamentos/excluir', requisicao);
    }

    buscar(requisicao) {
        return http.post('/api/motivo-de-afastamentos/buscar', requisicao);
    }

}